module.exports = __webpack_public_path__ + "/img/Solder-Paste-Pattern-8xGRp4.svg";